import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Button, CircularProgress, Alert, Stack } from '@mui/material';
import useDataFetch, { usePostDataFetch } from '../../utils/useDataFetch';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const JoinTeam = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    // 1. Lade Link-Informationen
    const { data: inviteData, error: inviteError, isLoading: inviteLoading } = useDataFetch({ url: `/teams/invite/${token}` });

    // 2. Beitreten-Funktion
    const { data: joinData, error: joinError, isLoading: joinLoading, postData: joinTeam } = usePostDataFetch();

    const handleJoin = async () => {
        await joinTeam({ url: `/teams/join/${token}`, aBody: { role: 'spieler' } }); // Default-Rolle als Spieler
    };

    const handleDecline = () => {
        navigate('/');
    };

    useEffect(() => {
        if (joinData?.success) {
            setTimeout(() => {
                navigate('/');
            }, 2000);
        }
    }, [joinData, navigate]);

    if (inviteLoading) return (
        <CircularProgress />
    );

    return (
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
            <Card sx={{ maxWidth: 450, width: '100%', textAlign: 'center', borderRadius: "12px", boxShadow: 6 }}>
                <CardContent sx={{ p: { xs: 3, sm: 5 } }}>

                    <Box sx={{
                        width: 64, height: 64, borderRadius: "12px", bgcolor: 'primary.light',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 3
                    }}>
                        <GroupAddIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                    </Box>

                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        Team-Einladung
                    </Typography>

                    {inviteError ? (
                        <Alert severity="error" sx={{ mt: 2, borderRadius: "12px" }}>{inviteError}</Alert>
                    ) : inviteData?.invite ? (
                        <>
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 4, px: 2 }}>
                                Du wurdest erfolgreich in das System eingeloggt und hast eine Einladung erhalten, dem Team <Typography component="span" fontWeight="bold" color="text.primary">"{inviteData.invite.team_name}"</Typography> beizutreten!
                            </Typography>

                            {!joinData?.success ? (
                                <Stack spacing={2}>
                                    <Button
                                        variant="contained"
                                        size="large"
                                        onClick={handleJoin}
                                        disabled={joinLoading}
                                        sx={{ borderRadius: "12px", fontWeight: 'bold' }}
                                    >
                                        Einladung annehmen
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        color="error"
                                        onClick={handleDecline}
                                        disabled={joinLoading}
                                        sx={{ borderRadius: "12px" }}
                                    >
                                        Ablehnen
                                    </Button>
                                </Stack>
                            ) : (
                                <Alert severity="success" sx={{ borderRadius: "12px", textAlign: 'left' }}>
                                    Erfolgreich beigetreten! Du wirst zur Startseite weitergeleitet...
                                </Alert>
                            )}

                            {joinError && <Alert severity="error" sx={{ mt: 2, borderRadius: "12px", textAlign: 'left' }}>{joinError}</Alert>}
                        </>
                    ) : (
                        <Typography>Einladung konnte nicht geladen werden.</Typography>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default JoinTeam;
